
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kJ9vR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ec644d026fe902e0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $ec644d026fe902e0$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "\u0412\u0441\u0435 \u0441\u0430\u0439\u0442\u044B",
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
    'navigation.global-shortcuts.apps.assets': "\u0410\u043A\u0442\u0438\u0432\u044B",
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': "\u0426\u0435\u043D\u0442\u0440 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438",
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': "\u0426\u0435\u043B\u0438",
    'navigation.global-shortcuts.apps.home': "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': "\u041F\u0440\u043E\u0435\u043A\u0442\u044B",
    'navigation.global-shortcuts.apps.studio': "\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F",
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': "\u0421\u0430\u0439\u0442 {name}",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(\u0441\u0435\u0439\u0447\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E)",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430 \u043F\u043E \u0432\u043D\u0435\u0448\u043D\u0435\u0439 \u0441\u0441\u044B\u043B\u043A\u0435",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': "(\u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0442\u0441\u044F)",
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': "(\u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0442\u0441\u044F)",
    'navigation.global-shortcuts.sites': "\u0421\u0430\u0439\u0442\u044B {productName}"
};

});


//# sourceMappingURL=ru.aa7303c5.js.map
